import { render, staticRenderFns } from "./ui_kit.vue?vue&type=template&id=37dbc711&scoped=true"
import script from "./ui_kit.vue?vue&type=script&lang=js"
export * from "./ui_kit.vue?vue&type=script&lang=js"
import style0 from "./ui_kit.vue?vue&type=style&index=0&id=37dbc711&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dbc711",
  null
  
)

export default component.exports